import gsap from "gsap";

import { Component } from "../extends";

export default () =>
	class Banner extends Component() {
		mounted() {
			this.circles =
				this.el.querySelectorAll(
					".c-banner__ripple .c-ripple__circle"
				) || [];
		}

		animations() {
			gsap.set(this.circles, { scale: 0, transformOrigin: "50% 50%" });

			this.anim = gsap.timeline();

			this.anim.to(
				this.circles,
				{
					scale: 1,
					ease: "back.out",
					duration: 0.6,
					stagger: 0.04,
				},
				0.2
			);

			this.anim.seek(0);
			this.anim.play();
		}
	};
